import { render, staticRenderFns } from "./EmployeesWhoOrderedDialog.vue?vue&type=template&id=3485e2ae&scoped=true"
import script from "./EmployeesWhoOrderedDialog.vue?vue&type=script&lang=js"
export * from "./EmployeesWhoOrderedDialog.vue?vue&type=script&lang=js"
import style0 from "./EmployeesWhoOrderedDialog.vue?vue&type=style&index=0&id=3485e2ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3485e2ae",
  null
  
)

export default component.exports